export const SET = 'agenda/SET';
export const LOADING = 'agenda/LOADING';
